import React, { memo, useMemo } from 'react';

import { Box, IconButton, Link, Typography } from '@mui/material';
import Avatar from '@sharedCR/common/Avatar';
import { CancelIcon, OpenIcon } from '@sharedCR/coreDesignSystem/icons';
import { CrmPaths } from 'app/configs/routesConfig/crm';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';
import { getPersonInitials } from 'utils/loanApplication';

import { BorrowersTestIds } from '../../Borrowers.testIds';
import { getContactDisplayName } from '../../crmContact.utils';
import { getContactAvatarStyles } from '../CrmContactSection.styles';

import {
  cardStyles,
  detailsStyles,
  nameStyles,
  removeButtonStyles,
  viewLinkStyles,
} from './LinkedContactCard.styles';

const AVATAR_SIZE = 42;

const LinkedContactCard = ({ contact, onRemove }) => {
  const name = getContactDisplayName(contact);

  const avatarStyles = useMemo(
    () => getContactAvatarStyles({ contact, size: AVATAR_SIZE }),
    [contact],
  );

  return (
    <Box sx={cardStyles}>
      <Avatar customStyles={avatarStyles} initials={getPersonInitials(contact)} />

      <Box sx={detailsStyles}>
        <Typography sx={nameStyles} variant="medium16">
          {name}
        </Typography>
        <Link
          data-testid={BorrowersTestIds.LINKED_CONTACT_CARD_VIEW_LINK}
          href={CrmPaths.contactDetail.generatePath({ contactId: contact.contactId })}
          rel="noopener noreferrer"
          sx={viewLinkStyles}
          target="_blank"
          variant="medium14"
        >
          View in CRM
          <OpenIcon size={IconSize[14]} />
        </Link>
      </Box>

      <IconButton
        aria-label="Unlink contact"
        data-testid={BorrowersTestIds.LINKED_CONTACT_CARD_UNLINK_BUTTON}
        sx={removeButtonStyles}
        title="Unlink contact"
        onClick={onRemove}
      >
        <CancelIcon size={IconSize[20]} />
      </IconButton>
    </Box>
  );
};

LinkedContactCard.propTypes = {
  contact: PropTypes.shape({
    contactId: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default memo(LinkedContactCard);
